<template>
    <ContactMap
      title="Kontakti"
      :latitude="42.66299"
      :longitude="21.159265"
      :contactCards="contactCards"
    />
  </template>
  
  <script>
  import ContactMap from "@/components/share/ContactPerson.vue";
  
  export default {
    components: { ContactMap },
    data() {
      return {
        contactCards: [
          {
            title: "Kabineti i Kryeprokurorit të Shtetit",
            items: [
              {
                label: "Pozita",
                icon: "fa-solid fa-chevron-right",
                value: "Kabineti i Kryeprokurorit të Shtetit"
              },
              {
                label: "Pozita",
                icon: "fa-solid fa-chevron-right",
                value: "Kabineti i Kryeprokurorit të Shtetit"
              },
              {
                label: "Email",
                icon: "fa-solid fa-envelope",
                value: "info.psh@rks-psh.org"
              },
              {
                label: "Tel/Fix",
                icon: "fa-solid fa-phone-volume",
                value: "+383 (0) 38 200 66902"
              },
              {
                label: "Email Zyrtar",
                icon: "fa-solid fa-envelope",
                value: "info.psh@rks-psh.org"
              },
              {
                label: "Adresa",
                icon: "fa-solid fa-location-dot",
                value:
                  'Rruga: "Luan Haradinaj, 10 000 Prishtinë, Kosovë'
              }
            ]
          },
          {
            title: "Administrata e Zyrës së Kryeprokurorit të Shtetit​",
            items: [
              {
                label: "Emri i plotë",
                icon: "fa-user-tie fa-chevron-right",
                value: "Lindita Memeti"
              },
              {
                label: "Pozita",
                icon: "fa-solid fa-chevron-right",
                value: "Administratore në ZKPSH"
              },
              {
                label: "Email",
                icon: "fa-solid fa-envelope",
                value: "info.psh@rks-psh.org"
              },
              {
                label: "Tel/Fix",
                icon: "fa-solid fa-phone-volume",
                value: "+383 (0) 38 200 66902"
              },
              {
                label: "Email Zyrtar",
                icon: "fa-solid fa-envelope",
                value: "info.psh@rks-psh.org"
              },
              {
                label: "Adresa",
                icon: "fa-solid fa-location-dot",
                value:
                  'Rruga: "Luan Haradinaj, 10 000 Prishtinë, Kosovë'
              }
            ]
          },
          {
            title: "Zyra për Komunikim Publik​",
            items: [
              {
                label: "Pozita",
                icon: "fa-solid fa-chevron-right",
                value: "Udhëheqëse e Zyrës për Komunikim Publik në ZKPSH"
              },
              {
                label: "Email",
                icon: "fa-solid fa-envelope",
                value: "info.psh@rks-psh.org"
              },
              {
                label: "Tel/Fix",
                icon: "fa-solid fa-phone-volume",
                value: "+383 (0) 38 200 66902"
              },
              {
                label: "Email Zyrtar",
                icon: "fa-solid fa-envelope",
                value: "info.psh@rks-psh.org"
              },
              {
                label: "Adresa",
                icon: "fa-solid fa-location-dot",
                value:
                  'Rruga: "Luan Haradinaj, 10 000 Prishtinë, Kosovë'
              }
            ]
          },
          {
            title: "Zyrtari për Qasje në Dokumente Publike",
            items: [
              {
                label: "Pozita",
                icon: "fa-solid fa-chevron-right",
                value: "Udhëheqëse e Zyrës për Komunikim Publik në ZKPSH"
              },
              {
                label: "Email",
                icon: "fa-solid fa-envelope",
                value: "info.psh@rks-psh.org"
              },
              {
                label: "Tel/Fix",
                icon: "fa-solid fa-phone-volume",
                value: "+383 (0) 38 200 66902"
              },
              {
                label: "Email Zyrtar",
                icon: "fa-solid fa-envelope",
                value: "info.psh@rks-psh.org"
              },
              {
                label: "Adresa",
                icon: "fa-solid fa-location-dot",
                value:
                  'Rruga: "Luan Haradinaj, 10 000 Prishtinë, Kosovë'
              }
            ]
          },
          {
            title: "Recepsioni",
            items: [
              {
                label: "Email",
                icon: "fa-solid fa-envelope",
                value: "info.psh@rks-psh.org"
              },
              {
                label: "Tel/Fix",
                icon: "fa-solid fa-phone-volume",
                value: "+383/38/200 66 925"
              },
              {
                label: "Email Zyrtar",
                icon: "fa-solid fa-envelope",
                value: "info.psh@rks-psh.org"
              },
              {
                label: "Adresa",
                icon: "fa-solid fa-location-dot",
                value:
                  'Rruga: "Luan Haradinaj, 10 000 Prishtinë, Kosovë'
              }
            ]
          }
        ]
      };
    }
  };
  </script>
  